import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../helper/BaseUrl";
import { clearAuthSession, getAuthToken } from "../helper/AuthSession";

const ProtectedRoute = ({ children }) => {
  const [isValid, setIsValid] = useState(null);
  const token = getAuthToken();

  useEffect(() => {
    let interval;

    const verifyUser = async () => {
      try {
        await axios.get(`${BaseUrl}api/rbac/my-permissions`, {
          headers: {
            "x-access-token": token,
          },
        });

        setIsValid(true);
      } catch (error) {
        const status = error.response?.status;
        if (status === 401 || status === 403) {
          clearAuthSession();
          setIsValid(false);
          return;
        }

        setIsValid(true);
      }
    };

    if (token) {
      verifyUser();
      interval = setInterval(() => {
        verifyUser();
      }, 600000);
    } else {
      setIsValid(false);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [token]);

  if (isValid === null) {
    return <div>Loading...</div>;
  }

  if (!isValid) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
